// General Vars
$win = jQuery(window);
var desktopWidth = 1024;
var tabletBreak = 850;
var mobileWidth = 650;


/* 0. Youtube Util */
var players = [];

ytUtil = function ($) {

}

function hasYT() {
    return jQuery('.youtubeVid').length > 0;
}

function loadYoutube() {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // Youtube Block Error
    jQuery('iframe.youtubeVid').after('<div class="youtubeError" style="display:none;"><p>Sorry, something went wrong and the YouTube video was unable to load.</p></div>');

    /* setTimeout(function() {
        jQuery('.youtubeError').show();
    }, 10000);
    */
}

function buildYoutubePlayer(containerId, videoId, trackCat, playerId) {
    console.log(videoId)
    var ytState = ["ended", "played", "paused"];
    vPlayer = new YT.Player(containerId, {
        videoId: videoId,
        height: '100%',
        width: '100%',
        playerVars: {
            'autohide': 1,
            'rel': 0,
            'showinfo': 0,
            'modestbranding': 1,
        },
        events: {
            'onReady': function (e) {
                // Remove if youtube is not blocked
                jQuery('.youtubeError').remove();

                //jQuery('#' + containerId).attr('name', playerId);
                jQuery('#' + containerId).attr('data-id', playerId);

                // Mute Video with mutedYoutubeVid class
                if (jQuery('#' + containerId).hasClass('mutedYoutubeVid')) {
                    e.target.mute();
                }

            },
            'onError': function (e) {
                console.log('YT Utility: Playback Error');
            },
            'onStateChange': function (e) {
                console.log(ytState[e.data]);
                if (ytState[e.data] === 'played') {
                    jQuery('.mw-vidPlayer .streamVideo.active').removeClass('paused').removeClass('ended').addClass('playing');
                    if (jQuery('.mw-vidPlayer .streamVideo.active.playing').length) {
                        videoTitle = jQuery('.streamVideo.playing h4').html();
                        _gaq.push(['_trackEvent', 'Video Player Grid', 'Play', videoTitle]);
                    }
                } else if (ytState[e.data] === 'paused') {
                    jQuery('.mw-vidPlayer .streamVideo.active').removeClass('playing').removeClass('ended').addClass('paused');
                    if (jQuery('.mw-vidPlayer .streamVideo.active.paused').length) {
                        videoTitle = jQuery('.streamVideo.paused h4').html();
                        _gaq.push(['_trackEvent', 'Video Player Grid', 'Pause', videoTitle]);
                    }
                } else if (ytState[e.data] === 'ended') {
                    jQuery('.mw-vidPlayer .streamVideo.active').removeClass('playing').removeClass('paused').addClass('ended');
                    if (jQuery('#' + containerId).hasClass('loopYoutubeVid') && jQuery(window).innerWidth() > 650) {
                        e.target.playVideo();
                    }
                    if (jQuery('.mw-vidPlayer .streamVideo.active.ended').length) {
                        videoTitle = jQuery('.streamVideo.ended h4').html();
                        _gaq.push(['_trackEvent', 'Video Player Grid', 'Stop', videoTitle]);
                    }
                }
                if (e.data == 1 || e.data == 2) {
                    if (!jQuery('#' + containerId).hasClass('loopYoutubeVid')) {
                        _gaq.push(['_trackEvent', trackCat, ytState[e.data], videoId]);
                    }
                }
            }
        }
    });
    return vPlayer;

}


function initYoutube() {
    if (hasYT()) {
        loadYoutube();
    }
}

//function onYouTubeIframeAPIReady()() {
window.onYouTubeIframeAPIReady = function () {

    // need to build our own youtube thing here
    // add a class so we can do a selector on the div
    if (hasYT()) {
        jQuery('.youtubeVid').each(function (i) {
            $this = jQuery(this);
            $this.attr('data-iteration', i);
            if ((videoId = $this.attr('name')) !== undefined) {
                $this.data('player', i);
                if ($this.attr('id') === undefined)
                    $this.attr('id', 'm' + videoId.replace(/-/g, "_"));
                containerId = $this.attr('id');
                trackCat = (cat = $this.data('trackCategory') !== undefined) ? cat : 'youtubeVideo';
                players[i] = buildYoutubePlayer(containerId, videoId, trackCat, i);
                console.log(players);

                // Cancel Autoplay on video that are not active on load
                if ($this.closest('.item').length && !$this.closest('.item').hasClass('active')) {
                    var vidSRC = $this.attr('src');
                    $this.attr('src', vidSRC.replace('autoplay=1', 'autoplay=0'));
                }

            }
        });

        window.players = players;

    }

}

function getPlayer(playerId) {
    return players[playerId];
}

function getPlayers() {
    return players;
}


/* 1. MediaWidget */
function clickEvents() {

    jQuery('.mediaWidget').each(function (i) {
        $this = jQuery(this);
        $evoCarousel = $this.find('.evolutionCarousel');
        $evoCarouselControl = $this.find('.carousel-control');
        $evoCarouselIndicators = $this.find('.carousel-indicators');
        $mwControlContainer = $this.find('.mw-controlContainer')
        $mwVideo = $this.find('.mw-video');
        $mwMedia = $this.find('.mw-media');
        $mwTextContainer = $this.find('.mw-textContainer');
        $sliderControlBar = $this.find('.sliderControlBar');
        $fa = $this.find('.fa');
        $photoCredit = $this.find('.mw-photoCredit');

        var carouselID = idGen();
        $evoCarousel.attr('id', carouselID);
        $evoCarouselControl.attr('href', '#' + carouselID);

        var streamVid = $this.find('.streamVideo');

        if (!$this.parent().hasClass('videoBackgroundPlayer')) {

            //count # of carousel items
            var itemNum = jQuery(this).find('.item').length;
            //if > 1 add carousel functionality
            if (itemNum > 1) {
                $mwVideo.hide();
                $evoCarouselIndicators.show();
                $mwControlContainer.show();
                $evoCarouselIndicators.find('li.active').attr('data-target', '#' + carouselID).attr('data-slide-to', '0');
                for (var i = 0; i < itemNum - 1; i++) {
                    $evoCarouselIndicators.append('<li data-target="#' + carouselID + '" data-slide-to="' + (i + 1) + '" />');
                }
                $evoCarousel.addClass('carouselFunc');
                if (itemNum > 3) {
                    $mwTextContainer.css('padding-bottom', '90px');
                }
            } else if (itemNum == 1) {
                $evoCarouselIndicators.hide();
                $mwControlContainer.hide();
                $mwVideo.hide();
            } else if (itemNum == 0) {
                $evoCarousel.hide();
            }
            //what type of media it is
            var mediaType = $mwMedia;
            ////detect if text only
            if (mediaType.find('img').length == 0) {
                $this.addClass('textOnly');
                $mwTextContainer.addClass('textOnly').css('position', 'relative').css('padding', '2em 0');
                $mwMedia.hide();
            }
            //link list display
            if ($this.find('.mw-linkList a').length == 0) {
                $this.find('.mw-linkList').hide();
            }

            if ($this.find('.mw-photoCredit').length > 0) {
                $this.find('.mw-photoCredit').show();
            }

            ////detect video
            if ($mwMedia.find('.youtubeVid').length > 0) {
                var videoW = jQuery(this).width();
                var videoH = videoW / (16 / 9);
                $this.find('.item').addClass('video').css('height', videoH);
                $mwTextContainer.find('.fa-youtube-play').show();
                $mwMedia.find('iframe').css('width', videoW).css('height', videoH);
                $mwMedia.find('img').addClass('videoThumb');
                $this.find('.mw-externalLink').hide();
                $this.find('.mw-playVidBTN').show().css('display', 'inline-block');
                //$this.find('.mw-photoCredit').hide();
                $this.find('.ctaLink.learnMore').hide();

                //reset video on slide
                $evoCarousel.on('slide', function () {
                    jQuery(this).find('img.videoThumb, .mw-playVidBTN, .shadowOverlay, .mw-textContainer').show();
                    jQuery(this).parent().parent().find('.overlayBanner').show();
                    players[i].seekTo();
                    players[i].stopVideo();
                });

            }

            //sliderControlBar
            $evoCarousel.mouseover(function () {
                $sliderControlBar.css('bottom', '0px');
            });
            $this.find('.evolutionCarousel').mouseleave(function () {
                $sliderControlBar.css('bottom', '-100px');
            });

            // video play button
            $this.find('.mw-playVidBTN, .video .mw-mediaContainer').click(function () {
                $thisPlayButton = jQuery(this);
                $thisParent = $thisPlayButton.parent();
                i = $thisParent.find('iframe').attr('data-iteration');
                console.log($thisParent.find('iframe'));
                $thisParent.find('img.videoThumb, .mw-playVidBTN, .shadowOverlay').hide();
                $thisParent.find('.mw-textContainer').hide();
                $thisParent.parent().parent().parent().parent().find('.overlayBanner').hide();
                console.log(i);
                players[i].playVideo();
            });

            // Video Player author option
            if ($this.find('.mw-vidPlayer').length) {

                var playingVid = null;
                var iteration = 0;
                $this.find('.overlayBanner').hide();
                $this.find('.mw-linkList').hide();
                $this.find('.mw-vidPlayer').removeClass('loading');

                jQuery('.youtubeVid').each(function () {
                    jQuery(this).attr('data-iteration', iteration);
                    iteration = iteration + 1;
                });

                // event click for first video only play button
                $this.find('.mw-vidPlayer .mw-playVidBTN').click(function () {

                    jQuery(this).hide();
                    jQuery(this).parent().parent().parent().find('.row-fluid .streamVideo:first').addClass('active');
                    jQuery(this).parent().find('.mw-youtubeVid:first').show();
                    players[i].playVideo();

                });

                // event click for video thumbnails
                streamVid.click(function () {

                    var $thisStreamVid = jQuery(this),
                        $parentContainer = jQuery(this).parent().parent().parent(),
                        vidID = $thisStreamVid.data('vid-id'),
                        youtubeVid = $parentContainer.find('.mw-youtubeVid[id="' + vidID + '"]');
                    console.log(youtubeVid[0]);
                    console.log(youtubeVid[0].name);
                    var vidName = youtubeVid[0].name;
                    if ($thisStreamVid.hasClass('playing')) { //clicking thumb & video is playing

                        players[vidName].pauseVideo();

                    } else if ($thisStreamVid.hasClass('paused')) { //clicking thumb & video is paused

                        players[vidName].playVideo();

                    } else if ($thisStreamVid.hasClass('ended')) { //clicking thumb & video has ended

                        players[vidName].seekTo();
                        players[vidName].playVideo();

                    } else { //clicking thumb of a new video

                        // stop & reset previous playing video
                        if (playingVid !== null) {
                            players[playingVid].seekTo();
                            players[playingVid].stopVideo();
                        }
                        console.log(vidName);
                        playingVid = vidName;

                        streamVid.removeClass('active').removeClass('playing').removeClass('paused').removeClass('ended');
                        $thisStreamVid.addClass('active');
                        $parentContainer.find('.mw-youtubeVid').hide();
                        $parentContainer.find('.mw-player .mw-playVidBTN').hide();
                        youtubeVid.show();
                        $parentContainer.find('#playerThumb').hide();
                        console.log(players[vidName]);
                        players[vidName].playVideo();

                    }



                });

            }

        }

    });

}

function checkSize() {
    console.log("running CheckSize");
    winWidth = $win.innerWidth();
    jQuery('.mediaWidget').each(function () {
        $this = jQuery(this);
        $thisParent = $this.parent();
        var mediaWidgetType = '';

        if ($this.hasClass('tileHero')) {
            mobileWidth = 605;
        }

        // important items
        $mwItems = $this.find('.item');
        $mwMedia = $this.find('.mw-media');
        $mwIframe = $mwMedia.find('iframe');
        $mwItemActive = $this.find('.item.active');
        $mwImages = $this.find('img');

        // sizes
        mwContainerWidth = $thisParent.width();
        var mwThisWidth = $this.width();
        var mwThisHeight = mwThisHeight = mwThisHeight = mwThisWidth / (16 / 9);

        // has elements
        var hasPhotoCredit = $this.find('.mw-photoCredit').length > 0 ? true : false;

        // initial cases for sizing and resizing
        if ($mwIframe.length != 0) {
            // video
            mediaWidgetType = 'video';

            var mwThisWidth = $this.width();
            var mwThisHeight = mwThisHeight = mwThisHeight = mwThisWidth / (16 / 9);
            if ($mwIframe.length > 3) {
                $this.find('.carousel-indicators').hide();
            }

            if (mwContainerWidth < desktopWidth && mwContainerWidth > mobileWidth) {
                $mwItemActive.css('height', '100%');
                $mwIframe.css({
                    'width': mwThisWidth,
                    'height': '100%'
                });
            } else {
                $mwItemActive.css('height', mwThisHeight);
                $mwIframe.css({
                    'width': mwThisWidth,
                    'height': mwThisHeight
                });
            }

        } else if ($mwImages.length == 0) {
            // text only
            mediaWidgetType = 'textonly';

        } else if ($mwItems.length == 1) {
            // single image
            mediaWidgetType = 'single';

            //$mwMedia.css('max-height', $mwItemActive.find('.mw-media img').height());

        } else {
            // slideshow

            mediaWidgetType = 'slideshow';

            $mwCarouselControl = $this.find('.carousel-control');
            $mwCarouselIndicators = $this.find('.carousel-indicators');
            $mwTextContainer = $this.find('.mw-textContainer');
            // display all of these

            if ($mwImages.length > 3 || $mwIframe.length > 3) {
                $mwCarouselIndicators.hide();
            }

        }


        if (mwContainerWidth >= desktopWidth) {
            // desktop size

            $this.removeClass('col-2 col-3').addClass('col-5');

            jQuery('mw-textContainer').css('min-height', '0');
            $mwItems.css('height', 'auto');

            if ($mwImages.length) {
                $mwImages.css({
                    'height': 'auto',
                    'width': '100%'
                });
            }

            if (mediaWidgetType == 'slideshow') {
                $mwCarouselControl.css('top', '80%');
                $mwMedia.css('max-height', $mwItemActive.find('.mw-media img').height());
            }

            if ($this.find('.mw-vidPlayer').length) {

                $this.find('.mw-stream .row-fluid').css('width', '100%');

            }

            // Height Override Functions
            if ($this.hasClass('slim') && winWidth > mobileWidth) {
                $this.css('height', ($this.outerWidth() / 3) * 2 - 2);

                $mwItems.css({
                    'height': ($this.outerWidth() / 3) * 2 - 2,
                    'min-height': 'none',
                });
            }


        } else if (mwContainerWidth < desktopWidth && mwContainerWidth > mobileWidth) {
            // tablet size

            $this.removeClass('col-2 col-5').addClass('col-3');
            $mwMedia.css('height', $mwItems.height());
            jQuery('mw-textContainer').css('min-height', '0');


            if (mediaWidgetType == 'slideshow') {
                $mwCarouselControl.css('top', '87%');
                $mwCarouselIndicators.css('top', '86%');
            }

            if (hasPhotoCredit) {
                $this.find('.mw-photoCredit').css('top', 'initial');
            }

            $mwItems.css('height', ($this.outerWidth() / 3) * 2 - 2);
            if (!$this.parent().hasClass('videoBackgroundPlayer')) {
                $mwItems.each(function () {
                    jQuery(this).find('.mw-textContainer').prependTo(this);
                    if ($mwIframe.length == 0) {
                        if ($this.hasClass('slim')) {
                            jQuery(this).find('img').css({
                                'width': '101%',
                                'height': 'auto'
                            });
                        } else {
                            jQuery(this).find('img').css({
                                'height': '101%',
                                'width': 'auto'
                            });
                        }
                        jQuery(this).find('img').each(function () {
                            if (jQuery(this).width() < jQuery(this).parent().width()) {
                                jQuery(this).css({
                                    'width': '101%',
                                    'height': 'auto'
                                });
                            }
                        });
                    }
                });
            }
            $mwItems.css('min-height', $mwTextContainer.outerHeight() + 45);
            $mwMedia.css('height', $mwItems.height());
            //$mwItems.find('.mw-media').css('max-height', $mwItems.find('.item.active .mw-media img').height());

            if ($this.find('.mw-vidPlayer').length) {

                var streamVid = jQuery('.streamVideo'),
                    streamVidWidth = streamVid.outerWidth(),
                    streamVidLength = streamVid.length;

                $this.find('.mw-stream .row-fluid').css('width', streamVidWidth * streamVidLength);

            }

            // Height Override Functions
            if ($this.hasClass('slim') && winWidth > mobileWidth) {
                $this.css('height', 'auto');
                $mwMedia.css('height', 300);
                $mwItems.css({
                    'height': 'auto',
                    'min-height': 385
                });
                //flexibility($this.find('.mw-textContainer')[0])
                // console.log(flexibility)
            }


        } else if (mwContainerWidth <= mobileWidth) {
            // mobile size

            $this.removeClass('col-3 col-5').addClass('col-2');
            $mwMedia.css('height', $this.find('.item.active .mw-media').width() / 2);


            $mwMedia.find('img').css({
                'width': '100%',
                'height': 'auto'
            });

            if (mediaWidgetType == 'slideshow') {
                var mwImageHeight = $mwItemActive.find('.mw-mediaContainer').height();
                $mwCarouselControl.css('top', mwImageHeight - 23);
                $mwCarouselIndicators.css('top', mwImageHeight - 28);
            }

            if (mediaWidgetType != 'video') {
                jQuery(this).find('.mw-textContainer').css('min-height', $mwMedia.width() / 2);
            } else {
                jQuery(this).find('iframe').css({
                    'width': '100%',
                    'height': '100%'
                });
            }

            if ($mwIframe.length == 0) {
                $mwItems.each(function () {
                    jQuery(this).find('.mw-textContainer').insertAfter(jQuery(this).find('.mw-mediaContainer'));
                    jQuery(this).find('img').css({
                        'height': '101%',
                        'width': 'auto'
                    });
                    jQuery(this).find('img').each(function () {
                        $this.find('.evolutionCarousel').on('slide', function () {
                            if (jQuery(this).width() <= jQuery(this).parent().width()) {
                                jQuery(this).css({
                                    'width': '101%',
                                    'height': 'auto'
                                });
                            }
                        });
                        if (jQuery(this).width() <= jQuery(this).parent().width()) {
                            jQuery(this).css({
                                'width': '101%',
                                'height': 'auto'
                            });
                        }
                    });
                });
            }
            $mwItems.find('.mw-media').css('max-height', $mwItems.find('.item.active .mw-media img').height());

            if ($this.find('.mw-vidPlayer').length) {

                $this.find('.mw-stream .row-fluid').css('width', '100%');

            }

            // Height Override Functions
            if ($this.hasClass('slim')) {
                $this.css('height', 'auto');
                $mwMedia.css('height', 300);
                jQuery(this).find('.mw-textContainer').css('min-height', 'none');
                $mwItems.css({
                    'height': 'auto',
                    'min-height': '385',
                });
                //flexibility($this.find('.mw-textContainer')[0])

            } else {
                $this.css('height', 'auto');
                $mwItems.css({
                    'height': 'auto',
                    'min-height': '0',
                });

            }


        }

        $this.find('.shadowOverlay').addClass('active');
        if (!$this.hasClass('slim')) {
            $mwMedia.css('height', $this.find('.item.active .mw-media').width() / 2);
        }

    });
}


/* General Functions
------------------------------------------------------------------------------- */
function idGen() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).toUpperCase();
}

/* 2. Video Player*/
/* Video List Widget Functions
            ------------------------------------------------------------------------------- */
function videoList_clickEvents() {

    jQuery('.videoListWidget').each(function (i) {
        $this = jQuery(this);
        $evoCarousel = $this.find('.evolutionCarousel');
        $evoCarouselControl = $this.find('.carousel-control');
        $evoCarouselIndicators = $this.find('.carousel-indicators');
        $mwControlContainer = $this.find('.mw-controlContainer');
        $sliderControlBar = $this.find('.sliderControlBar');
        $fa = $this.find('.fa');

        var carouselID = idGen();
        $evoCarousel.attr('id', carouselID);
        $evoCarouselControl.attr('href', '#' + carouselID);

        //count # of carousel items
        var itemNum = jQuery(this).find('.item').length;

        //if > 1 add carousel functionality
        if ($this.hasClass('carousel') && itemNum > 1) {
            $evoCarouselIndicators.show();
            $mwControlContainer.show();
            $evoCarouselIndicators.find('li.active').attr('data-target', '#' + carouselID).attr('data-slide-to', '0');
            for (var i = 0; i < itemNum - 1 && i < 2; i++) {
                $evoCarouselIndicators.append('<li data-target="#' + carouselID + '" data-slide-to="' + (i + 1) + '" />');
            }
        } else if ($this.hasClass('carousel') && itemNum == 1) {
            $evoCarouselIndicators.hide();
            $mwControlContainer.hide();
        }

        // video play button
        $this.find('.mw-playVidBTN, .vl-mediaContainer img').click(function () {
            if ($this.hasClass('stacked')) {
                resetVideo();
            }
            $thisPlayButton = jQuery(this);
            $thisParent = $thisPlayButton.parent();
            i = $thisParent.find('iframe').attr('data-iteration');
            $thisParent.find('img, .mw-playVidBTN, .shadowOverlay').hide();
            $thisParent.parent().find('.vl-textContainer').hide();
            $this.find('.item').removeClass('playing');
            $thisParent.parent().addClass('playing');
            console.log(i);
            players[i].playVideo();
        });

        //reset video
        function resetVideo() {
            $thisParent.find('img, .mw-playVidBTN, .shadowOverlay').show();
            $thisParent.parent().find('.vl-textContainer').show();
            players[i].seekTo();
            players[i].stopVideo();
        }

        $evoCarousel.on('slid', function () {
            resetVideo();
        });

    });

}

function videoList_checkSize() {

    var winWidth = $win.innerWidth();

    jQuery('.videoListWidget').each(function () {
        $this = jQuery(this);
        $thisParent = $this.parent();
        $item = jQuery(this).find('.item');
        $mediaContainer = jQuery(this).find('.vl-mediaContainer');
        $iframe = $this.find('iframe');
        var containerWidth = $thisParent.width();
        var videoW = $this.width();
        var videoH = videoW / (16 / 9);

        if (containerWidth >= desktopWidth || containerWidth >= mobileWidth && winWidth <= desktopWidth && winWidth > mobileWidth) {
            //desktop

            jQuery(this).removeClass('col-3').removeClass('col-2').addClass('col-5');
            $item.css('height', videoH);
            $mediaContainer.css('height', videoH);
            $iframe.css('width', videoW).css('height', videoH);

        } else if (containerWidth < desktopWidth && containerWidth > mobileWidth) {
            //tablet

            jQuery(this).removeClass('col-5').removeClass('col-2').addClass('col-3');
            $item.css('height', $item.outerWidth() * .666666);
            $mediaContainer.css('height', $item.outerWidth() * .666666);

        } else if (containerWidth <= mobileWidth) {
            //mobile
            console.log(containerWidth);
            jQuery(this).removeClass('col-5').removeClass('col-3').addClass('col-2');
            $item.css('height', $item.outerWidth() * .5);
            $mediaContainer.css('height', $item.outerWidth() * .5);
        }

        $this.find('.shadowOverlay').addClass('active');

    });
}


/* Video Background Player
------------------------------------------------------------------------------- */
function videoBackgroundPlayer_clickEvents() {

    jQuery('.videoBackgroundPlayer').each(function () {

        $this = jQuery(this);
        $videoControlNav = $this.find('.videoControlNav');
        $controlNav = $this.find('.controlNav');
        $mediaWidget = $this.find('.mediaWidget');
        $mwMedia = $this.find('.mw-media');
        $mwCarouselControl = $this.find('.carousel-control');
        $autoPlayVideo = $this.find('.mediaWidget.active .item.active iframe');
        console.log($autoPlayVideo);
        $evoCarousel = $mediaWidget.find('.evolutionCarousel');
        var currentVid = null;

        // Autoplays video if first slide is a video
        if ($autoPlayVideo.length > 0) {
            i = $autoPlayVideo[0].getAttribute('data-iteration');
            currentVid = i;
            console.log(currentVid);
            console.log(currentVid);
            console.log(currentVid);
            console.log(currentVid);
            console.log(currentVid);
            console.log(currentVid);
            console.log(currentVid);
        }
        

        // Carousel Functions
        $mediaWidget.each(function () {

            $thisMWItems = jQuery(this).find('.item');
            $thisMWCarouselControls = jQuery(this).find('.mw-controlContainer');

            if ($thisMWItems.length > 1) {
                $thisMWCarouselControls.show();
            }

        });

        $evoCarousel.bind('slid', function () {

            $autoPlayVideo = jQuery(this).find('.item.active iframe');

            // Stops Current Playing Video
            if (currentVid !== null) {
                console.log(currentVid);
                players[currentVid].seekTo();
                players[currentVid].stopVideo();
            }

            // Autoplays video if first slide is a video
            if ($autoPlayVideo.length > 0) {
                i = $autoPlayVideo.attr('data-iteration');
                players[i].seekTo();
                players[i].playVideo();
                currentVid = i;
            }

        });

        // Nav Control Functions if Multiple Tabs
        if ($mediaWidget.length === 1) {

            $this.removeClass('multiple');

        } else if ($mediaWidget.length > 1) {

            $controlNav.click(function () {
                tab = jQuery(this).attr('data-tab');
                $mediaWidget.removeClass('active');
                $controlNav.removeClass('active');
                jQuery(this).addClass('active');
                var currentMW = jQuery('.mediaWidget[data-tab="' + tab + '"]');
                currentMW.addClass('active');
                $autoPlayVideo = currentMW.find('.item.active iframe');

                // Stops Current Playing Video
                if (currentVid !== null) {
                    console.log(currentVid);
                    players[currentVid].seekTo();
                    players[currentVid].stopVideo();
                }

                // Autoplays video if first slide is a video
                if ($autoPlayVideo.length > 0) {
                    i = $autoPlayVideo.attr('data-iteration');
                    players[i].stopVideo();
                    players[i].seekTo();
                    players[i].playVideo();
                    currentVid = i;
                }

            });

            jQuery('.mobileNav').click(function () {
                index = jQuery(this).parent().parent().index();
                $videoControlNav.css({
                    'left': 'calc(-' + 100 * index + '% + ' + 64 * index + 'px)'
                });

            });

        }

        // Reveal Widget after scripts have loaded
        $this.addClass('loaded');

    });

}

function videoBackgroundPlayer_checkSize() {

    var winWidth = $win.innerWidth();

    jQuery('.videoBackgroundPlayer').each(function () {

        $this = jQuery(this);
        $mediaHeight = $this.find('.mediaWidget').height();
        $controlNav = $this.find('.videoControlNav a');

        if (winWidth >= desktopWidth) {

            if ($this.hasClass('multiple')) {

                $controlNav.css({
                    'height': 560 / $controlNav.length,
                    'width': '100%'
                }).parent().css({
                    'width': '30%'
                });

            }

        } else if (winWidth < desktopWidth && winWidth > mobileWidth) {

            if ($this.hasClass('multiple')) {

                $controlNav.css({
                    'width': winWidth / $controlNav.length,
                    'height': 'auto'
                }).parent().css({
                    'width': '100%'
                });

            }

        } else {

            controlHeight = jQuery('.mediaWidget.active .item .mw-mediaContainer').height();
            $this.find('.carousel-control').css('top', controlHeight);

            if ($this.hasClass('multiple')) {

                $mwMedia.css('height', $this.find('.mediaWidget.active').width() / 2);

                $controlNav.css({
                    'width': 'calc(' + 100 / $controlNav.length + '% - 64px)',
                    'height': '75px'
                }).parent().css({
                    'width': $controlNav.length * 100 + '%'
                });

            }

        }

    });

}

// Overlap Media Carousel

overlapCarousel = jQuery('.overlapCarousel');


/* Unique ID
------------------------------------------------------------------------------- */
function uniqID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).toUpperCase();
}


/* Image fill
------------------------------------------------------------------------------- */
jQuery.fn.imagefill = function (options) {

    var $container = this,
        imageAspect = 1 / 1,
        containersH = 0,
        containersW = 0,
        defaults = {
            runOnce: false,
            target: 'img',
            throttle: 200 // 5fps
        },
        settings = jQuery.extend({}, defaults, options);

    var $img = $container.find(settings.target).addClass('loading').css({
        'position': 'absolute'
    });

    // make sure container isn't position:static
    var containerPos = $container.css('position');
    $container.css({
        'overflow': 'hidden',
        'position': (containerPos === 'static') ? 'relative' : containerPos
    });

    // set containerH, containerW
    $container.each(function () {
        containersH += jQuery(this).outerHeight();
        containersW += jQuery(this).outerWidth();
    });

    imageAspect = $img.width() / $img.height();
    $img.removeClass('loading');
    fitImages();
    if (!settings.runOnce) {
        checkSizeChange();
    }

    function fitImages() {
        containersH = 0;
        containersW = 0;
        $container.each(function () {
            imageAspect = jQuery(this).find(settings.target).width() / jQuery(this).find(settings.target).height();
            var containerW = jQuery(this).outerWidth(),
                containerH = jQuery(this).outerHeight();
            containersH += jQuery(this).outerHeight();
            containersW += jQuery(this).outerWidth();

            var containerAspect = containerW / containerH;
            // old means of fitting image in container
            /*
            if (containerAspect < imageAspect) {
                // taller
                if ( containerW === 0 ) {
                    containerH = '100%';
                }
                jQuery(this).find(settings.target).css({
                    width: 'auto',
                    height: containerH,
                    top:0,
                    left:-(containerH*imageAspect-containerW)/2
                });
            } else {
                // wider
                jQuery(this).find(settings.target).css({
                    width: function() {
                        if ( containerW === 0 ) {
                            return 'auto';
                        } else {
                            return containerW
                        }
                    },
                    height: function() {
                        if ( containerW === 0 ) {
                            return '100%';
                        } else {
                            return 'auto'
                        }
                    },
                    top:-(containerW/imageAspect-containerH)/2,
                    left:0
                });
            } */

            // now, we will simply use object fit in the overlap CSS
        });
    }

    function checkSizeChange() {
        var checkW = 0,
            checkH = 0;
        $container.each(function () {
            checkH += jQuery(this).outerHeight();
            checkW += jQuery(this).outerWidth();
        });
        if (containersH !== checkH || containersW !== checkW) {
            fitImages();
        }
        setTimeout(checkSizeChange, settings.throttle);
    }

    return this;
};


/* Core Functions
------------------------------------------------------------------------------- */
overlapCarousel.each(function () {
    $this = jQuery(this);
    $innerCarousel = $this.find('.carousel-inner');
    $items = $this.find('.item');
    $controls = $this.find('.carousel-control');
    vidCount = 0;
    i = 0;

    // Determine the Type of Navigation
    if ($items.length > 1 && $this.hasClass('count')) {

        carouselID = uniqID();
        $this.attr('id', carouselID);
        controlContainer = jQuery('.controlContainer');
        controlTemp = jQuery('#controlCount');
        controlContainer.css('height', controlTemp.width() * $items.length);

        // Create slide navigation
        $items.each(function () {
            controlTemp.clone().attr('id', '').attr('data-slide-to', i).attr('data-track-label', i + 1).html(i + 1).appendTo(controlContainer).css({
                'display': 'block',
                'transform': 'translateY(' + 100 * i + '%)'
            });
            i++;
        });

        $controls = $this.find('.carousel-control');
        $controls.attr('data-target', '#' + carouselID);
        $firstControl = $this.find('.carousel-control:nth-child(3)');
        $activeControl = $firstControl;
        $activeControl.addClass('active');
        nextSlide = true;
        $this.on('slide click', function (event) {
            if (jQuery(event.target).hasClass('carousel-control')) {
                $activeControl = jQuery(event.target);
                nextSlide = false;
            } else if ($activeControl.next().length === 0 && jQuery(event.target).hasClass('carousel') && nextSlide === true) {
                $activeControl = $firstControl;
            } else if ($activeControl.next().length !== 0 && jQuery(event.target).hasClass('carousel') && nextSlide === true) {
                $activeControl = $activeControl.next();
            }
            $controls.removeClass('active');
            $activeControl.addClass('active');
            pos = $activeControl.attr('data-slide-to');
            jQuery('#activeCount').css('transform', 'translateY(' + 100 * pos + '%)');
            setTimeout(function () {
                nextSlide = true;
            }, 1000);
        });

    } else if ($items.length > 1 && !$this.hasClass('count')) {

        carouselID = uniqID();
        $this.attr('id', carouselID);
        $controls.attr('href', '#' + carouselID);

    } else {

        $controls.hide();
        jQuery('#activeCount').hide();

    }

    // AutoPlay
    if ($this.hasClass('auto')) {
        console.log('settingTheInterval');
        $this.carousel({
            interval: $this.data('interval')
        }).carousel();
    }

    // Video Controls
    $videoWrapper = $this.find('.videoWrapper');
    $videoWrapper.each(function () {

        $thisVideo = jQuery(this);
        $playBTN = $thisVideo.find('.playBTN');

        $playBTN.click(function () {
            $thisPlay = jQuery(this);
            vidCount = $thisPlay.parent().find('iframe.youtubeVid').attr('data-iteration');
            $thisPlay.parent().find('.videoThumbnail').hide();
            $thisPlay.hide();
            $controls.parent().addClass('offset');
            if ($innerCarousel.parent().parent().parent().hasClass('detailPage')) {
                $innerCarousel.parent().parent().parent().addClass('heroVidPlaying');
                if (jQuery('#mcaHeader').hasClass('dark')) {
                    jQuery('#mcaHeader').removeClass('dark');
                }
            }
            if ($innerCarousel.parent().hasClass('auto')) {
                $innerCarousel.parent().carousel('pause');
            }
            console.log(vidCount);
            players[vidCount].playVideo();
        });

        $this.on('slide', function () {
            players[vidCount].seekTo();
            players[vidCount].stopVideo();
            $videoWrapper.find('.videoThumbnail').show();
            $videoWrapper.find('.playBTN').show();
            $controls.parent().removeClass('offset');
            if ($innerCarousel.parent().parent().parent().hasClass('detailPage')) {
                $innerCarousel.parent().parent().parent().removeClass('heroVidPlaying');
            }
            if ($innerCarousel.parent().hasClass('auto')) {
                $innerCarousel.parent().carousel('cycle');
            }
        });

    });

});


/* Responsiveness
------------------------------------------------------------------------------- */
function overlapCarouselResize() {

    overlapCarousel.each(function () {
        $this = jQuery(this);
        $mediaContainer = $this.find('.mediaContainer');
        $mediaContainerWidth = $this.find('.item.active .mediaContainer').width();

        // Option to have images fill containers
        if ($this.hasClass('fillImgs')) {
            $mediaContainer.imagefill();
        }

        // Option to lock size to 9:16 aspect ratio
        // else defaults to 500px height
        if ($this.hasClass('vidAspect')) {
            $mediaContainer.css('height', $mediaContainerWidth * 9 / 16);
        } else {
            if (winWidth > tabletBreak) {
                $mediaContainer.css('height', '500px');
            } else {
                $mediaContainer.css('height', '370px');
            }
        }

    });

}



function checkSizeNE() {
    $neWidget = jQuery('.newsEvents-widget');
    $neWidgetParent = jQuery('.newsEventsContainer');
    var winWidth = $win.innerWidth();
    var neContainerWidth = $neWidgetParent.width();
    var nevwContainerW = $neWidgetParent.width();

    if (jQuery('.newsEvents-widget .evo-moreLink').length < 2) {
        jQuery('.newsEvents-widget .evo-moreLink').css('width', '100%');
    }

    $neNonFeatured = jQuery('.ne-nonFeatureImg');

    $neFeature = jQuery('.newsEvents-widget .ne-feature');
    $neFeatureInfoContainer = jQuery('.newsEvents-widget .featureInfoContainer');
    $neTile = jQuery('.newsEvents-widget .ne-tile');
    $neTileFeature = jQuery('.newsEvents-widget .ne-tile.featureTile');

    $event1 = jQuery('.newsEvents-widget .event01');
    $event2 = jQuery('.newsEvents-widget .event02');
    $event3 = jQuery('.newsEvents-widget .event03');
    $event4 = jQuery('.newsEvents-widget .event04');
    $event5 = jQuery('.newsEvents-widget .event05');

    $neNonFeatured.each(function () {
        $thisImage = jQuery(this).find('img');
        imgW = $thisImage.width();
        imgH = $thisImage.height();
        if (imgW == imgH) {
            $thisImage.addClass('square');
        } else if (imgW > imgH) {
            $thisImage.addClass('width');
        } else {
            $thisImage.addClass('height');
        }
    });

    $featuredListing = jQuery('.featured-listing');
    $featuredListingImage = $featuredListing.find('img');
    $featureImage = jQuery('.ne-feature img');

    var featureLisitingContainerH = $featuredListing.height();
    var featureListingImgH = $featuredListingImage.height();

    var neTileW = $neTile.outerWidth();
    var neFeatureW = $neFeature.width();

    if (featureLisitingContainerH > featureListingImgH) {
        $featuredListingImage.css({
            'height': '100%',
            'width': 'auto'
        });
    } else {
        $featuredListingImage.css({
            'height': 'auto',
            'width': '100%'
        });
    }

    if (winWidth >= desktopWidth) {

        jQuery('#newsEvents .ne-feature01 .ne-news').not('.featureTile').parent().detach().prependTo('#newsEvents .nonFeatured .span2:first');
        jQuery('#newsEvents .ne-feature02 .ne-news').not('.featureTile').parent().detach().prependTo('#newsEvents .nonFeatured .span2:last');
        jQuery('#newsEvents .span8 .ne-news:last').show();
        $neTile.css('height', neTileW);
        $neFeature.css('height', neFeatureW - 1);
        $featureImage.each(function () {
            if ($featureImage.width() >= $featureImage.height()) {
                $featureImage.css({
                    'width': '100%',
                    'height': 'auto'
                });
            } else {
                $featureImage.css({
                    'height': '100%',
                    'width': 'auto'
                });
            }
        });

        //config01
        if (jQuery('#newsEvents').hasClass('config01')) {
            jQuery('#newsEvents .event03 .arrow').removeClass('arrowLeft').addClass('arrowUp');
            jQuery('#newsEvents .ne-feature02 .ne-tile.featureTile').css('margin-top', neTileW);
            jQuery('#newsEvents .event03').detach().prependTo('#newsEvents .span2:last');
            jQuery('#newsEvents .event04').detach().appendTo('#newsEvents .span8');
            jQuery('#newsEvents .event05').detach().appendTo('#newsEvents .span2.first');
        }
        //config02
        else if (jQuery('#newsEvents').hasClass('config02')) {
            jQuery('#newsEvents .ne-feature01 .ne-tile').css('margin-top', neTileW);
            jQuery('#newsEvents .event03 .arrow').removeClass('arrowRight').addClass('arrowUp');
            jQuery('#newsEvents .event04 .arrow').removeClass('arrowDown').addClass('arrowRight');
            jQuery('#newsEvents.config02 .event05 .arrow').removeClass('arrowRight').addClass('arrowUp');
            jQuery('#newsEvents .feature02').detach().appendTo('#newsEvents .featureInfoContainer.col-5');
            jQuery('#newsEvents .feature01').detach().prependTo('#newsEvents .featureInfoContainer.col-5');
            jQuery('#newsEvents .event03').detach().prependTo('#newsEvents .span2.first');
            jQuery('#newsEvents .event03 .ne-nonFeatureImg').detach().prependTo('#newsEvents .event03');
            jQuery('#newsEvents .event04').insertAfter('#newsEvents .event02');
            jQuery('#newsEvents .event05').detach().appendTo('#newsEvents .span2:last');
            jQuery('#newsEvents .event05 .ne-nonFeatureImg').detach().prependTo('#newsEvents .event05');
        }

    } else if (winWidth < desktopWidth && winWidth > mobileWidth) {
        // tablet
        $neFeature.show();
        jQuery('#newsEvents .featureInfoContainer.col-3').show();
        jQuery('#newsEvents .nonFeatured').show();
        jQuery('#newsEvents .arrow').show();
        jQuery('#newsEvents .featureInfoContainer .ev-info').css('width', 'initial');

        var neTileW = $neTile.outerWidth();
        var neFeatureW = $neFeature.width();
        $neTile.css('height', neTileW);
        //$neTileFeature.css('height', neTileW * 2);
        $neFeature.css('height', neFeatureW - 2);
        $featureImage.each(function () {
            if ($featureImage.width() >= $featureImage.height()) {
                $featureImage.css({
                    'width': '100%',
                    'height': 'auto'
                });
            } else if (featureImgW < featureImgH) {
                $featureImage.css({
                    'height': '100%',
                    'width': 'auto'
                });
            }
        });

        jQuery('#newsEvents').find('.span2:first .ne-news').parent().detach().appendTo('.ne-feature01');
        jQuery('#newsEvents').find('.span2:last .ne-news').parent().detach().appendTo('.ne-feature02');
        jQuery('#newsEvents .ev-info').css('width', 'auto');

        //config01
        if (jQuery('#newsEvents').hasClass('config01')) {
            jQuery('#newsEvents .ne-feature02 .ne-tile').css('margin-top', '0');
            jQuery('#newsEvents .event03 .arrow').removeClass('arrowUp').addClass('arrowLeft');
            jQuery('#newsEvents .event03').detach().prependTo('#newsEvents .span9');
            jQuery('#newsEvents .event04').detach().appendTo('#newsEvents .span9');
            jQuery('#newsEvents .event05').detach().prependTo('#newsEvents .span2:last');
        }
        //config02
        else if (jQuery('#newsEvents').hasClass('config02')) {
            jQuery('#newsEvents .ne-feature01 .ne-tile').css('margin-top', '0');
            jQuery('#newsEvents .event03 .arrow').removeClass('arrowUp').addClass('arrowRight');
            jQuery('#newsEvents .event04 .arrow').removeClass('arrowRight').addClass('arrowDown');
            jQuery('#newsEvents.config02 .event05 .arrow').removeClass('arrowUp').addClass('arrowRight');

            jQuery('#newsEvents .event03').detach().prependTo('#newsEvents .span9');
            jQuery('#newsEvents .event03 .ne-nonFeatureImg').detach().appendTo('#newsEvents .event03 .ne-eventContainer');
            jQuery('#newsEvents .event04').detach().prependTo('#newsEvents .span2:last');
            jQuery('#newsEvents .event05').detach().appendTo('#newsEvents .span9');
            jQuery('#newsEvents .event05 .ne-nonFeatureImg').detach().appendTo('#newsEvents .event05 .ne-eventContainer');
        }
        jQuery('#newsEvents .span8 .ne-news:last').hide();
    } else {
        // mobile
        $neTile.css('height', 'auto');
        jQuery('#newsEvents .ne-feature01 .ne-news').not('.featureTile').parent().detach().prependTo('#newsEvents .span2:first');
        jQuery('#newsEvents .ne-feature02 .ne-news').not('.featureTile').parent().detach().prependTo('#newsEvents .span2:last');

        jQuery('#newsEvents a .ne-event, #ne-listing .item .ne-event').each(function () {
            var neContainerW = jQuery(this).parent().parent().width();
            var neDateW = jQuery(this).find('.ev-date').width();
            jQuery(this).find('.ev-info').css('width', neContainerW - neDateW - 80);
        });
        jQuery('#newsEvents .ne-feature').hide();
        jQuery('#newsEvents .nonFeatured').hide();
        jQuery('#newsEvents .arrow').hide();
    }

    // sepcifics
    if (nevwContainerW >= desktopWidth) {
        jQuery('.newsEvents-widget').each(function () {
            $this = jQuery(this);
            $this.removeClass('col-2 col-3');
            var nevwTile = $this.find('.nevw-tile');
            var nevwTileW = $this.find('.nevw-tile').outerWidth();
            nevwTile.css('height', nevwTileW);
            $this.find('.col-md-4.first .nevw-tileContainer:last, .col-md-4.second .nevw-tileContainer:first').each(function () {
                $thisSwap = jQuery(this);
                textTile = $thisSwap.find('.ne-event');
                textTile.detach().prependTo($thisSwap);
            });
            $this.find('.nevw-tileContainer').hover(function () {
                jQuery(this).find('.ne-news .arrow').toggleClass('blue').toggleClass('white');
            });
        });
    } else if (neContainerWidth < desktopWidth && neContainerWidth > mobileWidth) {
        jQuery('.newsEvents-widget').each(function () {
            $this = jQuery(this);
            $this.removeClass('col-2').addClass('col-3');
            $this.find('.arrow').show();
            nevwTileW = $this.find('.nevw-tile').outerWidth();
            $this.find('.nevw-tile').css('height', nevwTileW);
            $this.find('.col-md-4.first .nevw-tileContainer:last, .col-md-4.second .nevw-tileContainer:first').each(function () {
                $thisSwap = jQuery(this);
                textTile = $thisSwap.find('.ne-event');
                textTile.detach().prependTo($thisSwap);
            });
            $this.find('.nevw-tileContainer').hover(function () {
                jQuery(this).find('.ne-news .arrow').toggleClass('blue').toggleClass('white');
            });
        });
    } else if (neContainerWidth <= mobileWidth) {
        jQuery('.newsEvents-widget').each(function () {
            console.log(neContainerWidth);
            $this = jQuery(this);
            $this.removeClass('col-3').addClass('col-2');
            $this.find('.arrow').hide();
            $this.find('.nevw-tile').css('height', 'auto');
            $this.find('.col-md-4.first .nevw-tileContainer:last, .col-md-4.second .nevw-tileContainer:first').each(function () {
                $thisSwap = jQuery(this);
                textTile = $thisSwap.find('.ne-event');
                textTile.detach().appendTo($thisSwap);
            });
            $this.find('.ne-event').each(function () {
                var neContainerW = jQuery(this).parent().parent().parent().width();
                var neDateW = jQuery(this).find('.ev-date').width();
                jQuery(this).find('.ev-info').css('width', neContainerW - neDateW - 80);
            });
        });
    }

    //creates square tiles
    $neWidget.find('.genericSquareTile').each(function () {
        $this = jQuery(this);
        $this.css('height', $this.outerWidth());
    });

}

/* Init Function */
jQuery(window).load(function () {
    initYoutube();
    if (jQuery('.mediaWidget').length) {
        clickEvents();
        checkSize();
        jQuery(window).resize(checkSize);
    }
    if (jQuery('.videoListWidget').length) {
        videoList_checkSize();
        videoList_clickEvents();
        jQuery(window).resize(videoList_checkSize);
    }

    if (jQuery('.videoBackgroundPlayer').length) {
        videoBackgroundPlayer_clickEvents();
        videoBackgroundPlayer_checkSize();
        jQuery(window).resize(videoBackgroundPlayer_checkSize);
    }
    if (jQuery('.newsEvents-widget').length) {
        checkSizeNE();
        jQuery(window).resize(checkSizeNE);
    }
    overlapCarouselResize();
    $win.resize(overlapCarouselResize);
});